
import { Component } from '@angular/core';
import { ScorecardComponent } from '../../components/scorecard/scorecard.component';

@Component({
  selector: 'app-scorecard-stats',
  imports: [ScorecardComponent],
  templateUrl: './scorecard-stats.component.html',
  styleUrl: './scorecard-stats.component.scss'
})
export class ScorecardStatsComponent {
}
